import { showRestrictionPopup } from '@/Poker/redux/slices/lobbySlice';
import { hideRestrictionPopup } from '@/Poker/redux/slices/lobbySlice';
import { useDispatch, useSelector } from 'react-redux'
import usePlayerDetails from './usePlayerDetails';
import { RESTRICTION_LOCATION, RESTRICTION_PSEUDO_LOCKED } from '@/Poker/data/Constants';
import { messageToNativeClient } from '@/Common/utils/platformCommunicationUtil';

export default function useRestrictions() {
  const location_games = useSelector((state) => state.lobby.location_games);
  const location_addcash = useSelector((state) => state.lobby.location_addcash)
  const userComplianceLocation = useSelector((state) => state.lobby.userComplianceLocation);
  const showRestriction = useSelector((state) => state.lobby.showRestrictionPopup);
  const restrictionType = useSelector((state) => state.lobby.restrictionType);
  const dispatch = useDispatch();
  const { pseudo, userConsentFlag, gameJoinCheckAck } = usePlayerDetails();

  const restrictionCheck = (func, checkOtherRestrictions = false, condition = location_games) => {
    // console.log('Consent Flags >>> ', userConsentFlag, gameJoinCheckAck);
    if (!condition) {
      return dispatch(showRestrictionPopup({ type: RESTRICTION_LOCATION }));
    } else if (checkOtherRestrictions) {
      // Add Conditions to check for Pseudo Player, etc. Any other player status based restrictions. 
      if (pseudo) {
        return dispatch(showRestrictionPopup({ type: RESTRICTION_PSEUDO_LOCKED }));
      }
      if (
        (userConsentFlag || gameJoinCheckAck)
      ) {
        // console.log('Consent Flags 2>>> ', userConsentFlag, gameJoinCheckAck);
        messageToNativeClient({ type: "gameJoinCheck" });
        return;
      }
    }
    return func();
  }

  const openRestrictionDrawer = () => {
    return dispatch(showRestrictionPopup());
  }

  const closeRestrictionDrawer = () => {
    return dispatch(hideRestrictionPopup());
  }

  return {
    location_games,
    location_addcash,
    userComplianceLocation,
    isAllowed: !userComplianceLocation & !location_games,
    restrictionCheck,
    showRestriction,
    restrictionType,
    openRestrictionDrawer,
    closeRestrictionDrawer,
  }
}
